// extracted by mini-css-extract-plugin
module.exports = {"guideLinks":"educators-module--guide-links--2gvzi","column":"educators-module--column--wABnk"};